import { useRef, useState, useEffect, MutableRefObject } from "react";

import { ResizeObserver } from "resize-observer";

export function useMeasure(
  selector?: string,
): [
  { ref: React.RefObject<HTMLDivElement> },
  { left: number; top: number; width: number; height: number },
] {
  const ref = useRef<HTMLDivElement>(null);
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [ro] = useState(
    () => new ResizeObserver(([entry]) => set(entry.contentRect)),
  );
  useEffect(() => {
    const measured = selector
      ? ref.current?.querySelector(selector)
      : ref.current;
    if (measured) ro.observe(measured);
    return () => ro.disconnect();
  }, []);
  return [{ ref }, bounds];
}

export default useMeasure;
